// extracted by mini-css-extract-plugin
module.exports = {"FullWidth":"MasterPasswordAuthentication_FullWidth__16xdU"};